import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { ready } from "../../../Shared/api/apiUtils";
import { Announcement } from "../../../Shared/components/Announcement";
import { features } from "../../../Shared/features";
import { scrollToTop } from "../../../Shared/utils/browser";
import { getPage } from "../../custom_api/api";
import { ActivityClustersPage } from "../pages/activity_clusters_page";
import { ActivityDetailPage } from "../pages/activity_detail_page";
import { BlogOverview } from "../pages/blogOverview/blogOverviewWidget";
import { BlogPost } from "../pages/blogPost/blogPostWidget";
import { CollectionPage } from "../pages/collection_page";
import { GeneralContentPage } from "../pages/general_content_page";
import { HomePage } from "../pages/home_page";
import { LocationOverviewPage } from "../pages/Location/LocationOverviewPage/location_overview_page";
import { LocationPage } from "../pages/Location/LocationPage/LocationPageLayout";
import { LocationDetailPage } from "../pages/location_detail_page";
import { NewsItem } from "../pages/newsItem/newsItemLayout";
import { NewsletterSignupPage } from "../pages/newsletter_signup_page";
import { NewsOverview } from "../pages/newsOverview/newsOverviewWidget";
import { ReportOverviewPage } from "../pages/report_overview_page";
import { drupalHomepagePath } from "./application";
import { Error } from "./error";
import { Loader } from "./loader";
const pageRendererStateZero = {
    page: 'loading',
    homepage: 'loading'
};
export class PageRenderer extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.route != this.props.route) {
            this.loadRoute();
        }
    }
    componentDidMount() {
        this.initialLoad();
    }
    initialLoad() {
        if (this.props.route == drupalHomepagePath) {
            getPage(drupalHomepagePath, this.props.params).then((x)=>this.setState((s)=>({
                        ...s,
                        page: x,
                        homepage: x
                    })));
        } else {
            getPage(this.props.route, this.props.params).then((x)=>this.setState((s)=>({
                        ...s,
                        page: x
                    })));
            getPage(drupalHomepagePath, this.props.params).then((x)=>this.setState((s)=>({
                        ...s,
                        homepage: x
                    })));
        }
    }
    loadRoute() {
        this.setState((s)=>({
                ...s,
                page: "loading"
            }), ()=>{
            getPage(this.props.route, this.props.params).then((x)=>this.setState((s)=>({
                        ...s,
                        page: x
                    })));
            scrollToTop();
        });
    }
    render() {
        const p = this.props;
        const s = this.state;
        const pg = s.page;
        const page = pg == "loading" ? /*#__PURE__*/ _jsx(Loader, {}) : pg == "error" || pg == null ? /*#__PURE__*/ _jsx(Error, {}) : pg.kind == "activityDetail" ? /*#__PURE__*/ _jsx(ActivityDetailPage, {
            ...pg,
            regions: p.regions,
            selectedPeriod: p.selectedPeriod,
            selectedRegion: p.selectedRegion,
            selectPeriod: p.selectPeriod,
            selectRegion: p.selectRegion
        }) : pg.kind == "activityClusters" ? /*#__PURE__*/ _jsx(ActivityClustersPage, {
            ...pg,
            regions: p.regions,
            selectedPeriod: p.selectedPeriod,
            selectedRegion: p.selectedRegion,
            selectedCluster: p.selectedCluster,
            selectPeriod: p.selectPeriod,
            selectRegion: p.selectRegion,
            selectCluster: p.selectCluster,
            toggleArchive: p.toggleArchive,
            showArchive: p.showArchive
        }) : pg.kind == "blogPost" ? /*#__PURE__*/ _jsx(BlogPost, {
            ...pg
        }) : pg.kind == "blogOverview" ? /*#__PURE__*/ _jsx(BlogOverview, {
            ...pg
        }) : pg.kind == "newsItem" ? /*#__PURE__*/ _jsx(NewsItem, {
            ...pg
        }) : pg.kind == "newsOverview" ? /*#__PURE__*/ _jsx(NewsOverview, {
            ...pg
        }) : pg.kind == "generalContent" ? /*#__PURE__*/ _jsx(GeneralContentPage, {
            ...pg
        }) : pg.kind == "collection" ? /*#__PURE__*/ _jsx(CollectionPage, {
            ...pg
        }) : pg.kind == "newsletterSignup" ? /*#__PURE__*/ _jsx(NewsletterSignupPage, {
            ...pg
        }) : pg.kind == "locationDetail" ? /*#__PURE__*/ _jsx(LocationDetailPage, {
            ...pg,
            resetPeriod: p.resetPeriod,
            localizationProps: p.localizationProps,
            regions: p.regions,
            homePageData: s.homepage
        }) : pg.kind == "locationOverviewContent" ? /*#__PURE__*/ _jsx(LocationOverviewPage, {
            ...pg
        }) : pg.kind == "locationContent" ? /*#__PURE__*/ _jsx(LocationPage, {
            ...pg
        }) : pg.kind == "reportOverview" ? /*#__PURE__*/ _jsx(ReportOverviewPage, {
            ...pg
        }) : pg.kind == "home" ? /*#__PURE__*/ _jsx(HomePage, {
            ...pg,
            localizationProps: p.localizationProps
        }) : /*#__PURE__*/ _jsx(_Fragment, {});
        const showAnnouncement = ready(pg) && features().showAnnouncementOnPage(pg);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                showAnnouncement && /*#__PURE__*/ _jsx(Announcement, {
                    homepage: this.state.homepage
                }, "general-announcement"),
                page
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = pageRendererStateZero;
    }
}
